import { iconImage, iconMovie, iconVoice } from '../../../assets/images';

// 配送種別
export const DELIVERY_TYPE = {
  delivery: { value: 'delivery' },
  hand_over: { value: 'hand_over' },
} as const;

// 配送ステータス
export const DELIVERY_STATUS = {
  unprocessed: {
    text: '準備中',
    value: 'unprocessed',
    color: 'var(--color-black)',
  },
  preparing: {
    text: '準備中',
    value: 'preparing',
    color: 'var(--color-black)',
  },
  inprocess: {
    text: '準備中',
    value: 'inprocess',
    color: 'var(--color-black)',
  },
  shipped: {
    text: '発送済',
    value: 'shipped',
    color: 'var(--color-black)',
  },
  complete: {
    text: 'お届け済',
    value: 'complete',
    color: 'var(--color-warmgray)',
  },
  no_address: {
    text: '住所未登録',
    value: 'no_address',
    color: '',
  },
  cancel: {
    text: 'キャンセル',
    value: 'cancel',
    color: 'var(--color-black)',
  },
  return: { text: '返品', value: 'return', color: 'var(--color-black)' },
};

// くじ景品ラベル種別
export const LotteryPrizeType = {
  image: { text: '画像', value: 'image', src: iconImage.src },
  video: { text: '動画', value: 'video', src: iconMovie.src },
  audio: { text: '音声', value: 'audio', src: iconVoice.src },
  text: { text: 'テキスト', value: 'text', src: '' },
  goods: { text: '物', value: 'goods', src: '' },
} as const;

// くじイベント開催ステータス
export const LOTTERY_STATUS = {
  upcoming: { text: '開催予定', value: 'upcoming', labelColor: 'black' },
  is_session: { text: '開催中', value: 'is_session', labelColor: 'primary' },
  later: { text: '終了', value: 'later', labelColor: 'lightgray' },
};

// くじ引き制限種別
export const LOTTERY_DRAW_TYPE = {
  unlimited: { text: '無制限', value: 'unlimited' },
  only_serial_code: { text: 'シリアルコードのみ', value: 'only_serial_code' },
  first_serial_code: {
    text: '初回シリアルコード必須',
    value: 'first_serial_code',
  },
} as const;

// 獲得景品の住所未入力状態
export const SHIPPING_OVER_TYPE = {
  reception: { text: '受付中', value: 'reception' },
  over: { text: '入力期限切れ', value: 'over' },
  ok: { text: '入力済み', value: 'ok' },
};

// ログイン連携プロバイダー定義
export const OAUTH_PROVIDER = {
  daccount: { text: 'dアカウント', value: 'daccount' },
};

// くじ景品ダウンロードステータス
export const LOTTERY_DOWNLOAD_STATUS = {
  disabled: { text: 'ダウンロード不可', value: 'disabled' },
  pending: { text: 'ダウンロード待ち', value: 'pending' },
  available: { text: 'ダウンロード可能', value: 'available' },
  preparing: { text: 'ダウンロード準備中', value: 'preparing' },
};

// 景品交換
export const TRADE_TYPE = {
  tradeList: { text: 'イベント一覧', value: 'tradeEventList' },
};

// 配送バージョン
export const DELIVERY_VERSION = {
  v2: { text: 'v2', value: '2.0' },
};
